

<app-modal-header
  (close)="close()">
  <span slot="breadcrumb">
    <span>
      {{ 'admin.session-lecturer-attendance-modal.title' | translate }}      
      <ng-container *ngIf="sessionData">
        • <span class="font-normal">{{ sessionData.index + 1 }}. {{ 'admin.session-lecturer-attendance-modal.session' | translate }}</span>
      </ng-container>
    </span>
  </span>
  <span slot="title">
    <ng-container *ngIf="type === SessionLecturerType.REGULAR">
      {{ sessionData?.shopItem?.title }}
    </ng-container>
    <ng-container *ngIf="type === SessionLecturerType.SUBSTITUTION">
      {{ 'admin.session-lecturer-attendance-modal.subtitute' | translate }}
    </ng-container>
  </span>

  <app-session-info-icons [session]="sessionData ?? undefined" [showDate]="true" class="mt-2 block"></app-session-info-icons>


</app-modal-header>

<div class="modal-body">

  <app-session-lecturer-attendance-input-group #sessionLecturerAttendanceInputGroup [sessionId]="sessionId" [type]="type"></app-session-lecturer-attendance-input-group>

</div>

<div class="modal-footer">
  <app-modal-footer-menu [items]="footerMenuItems"></app-modal-footer-menu>
</div>

